import { AbstractApi, ApiBaseResponse } from '../../../common/api'
import { CreateOrganizationDto, Organization } from '../types/organization.types'

class OrganizationApi extends AbstractApi {
  protected url = '/organizations'

  public async getById(id: number): Promise<ApiBaseResponse<Organization>> {
    const { data: response } = await this.get<ApiBaseResponse<Organization>>(this.url.concat(`/${id}`))

    return response
  }

  public async create(dto: CreateOrganizationDto): Promise<Organization> {
    const { data: response } = await this.post<Organization>(this.url, dto)

    return response
  }

  public async list(): Promise<Organization[]> {
    const { data: response } = await this.get<Organization[]>(this.url, [])

    return response
  }

  public async checkIsExist(ogrn: string): Promise<ApiBaseResponse<{ exists: boolean }>> {
    const { data: response } = await this.post<ApiBaseResponse<{ exists: boolean }>>(this.url.concat('/check-is-exists'), { ogrn })

    return response
  }
}

export const organizationApi = new OrganizationApi()
